import {ocCreateAccountWidgetComponent} from './create-account-widget-webu';

export const CREATE_ACCOUNT_WIDGET_ROUTES = [
  {
    path: '',
    component: ocCreateAccountWidgetComponent,
    outlet: 'create-account-widget'
  }
];
